import "pixi.js";
import { EMPTY, interval, Observable } from "rxjs";
import { share } from "rxjs/operators";
import { appCanvas } from "../features/app/appCanvas";
var UtilTick = /** @class */ (function () {
    function UtilTick() {
        this.frame$ = new Observable(function (subscriber) {
            appCanvas.ticker.add(function (deltaTime) { return subscriber.next(deltaTime); });
        }).pipe(share());
        this.second$ = interval(1000).pipe(share());
        this.getInterval$ = function (ms) {
            return ms ? interval(ms).pipe(share()) : EMPTY;
        };
    }
    return UtilTick;
}());
export var utilTick = new UtilTick();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilTick.ts
// module id = 84
// module chunks = 3